import _ from 'lodash';
window._ = _;

import Cookies from 'js-cookie';
window.Cookies = Cookies;

window.app = {
    modules: {},

    isRequired(moduleName) {
        let modules = $('html').attr('data-modules') || '';
        return modules.split('|').indexOf(moduleName) !== -1;
    },

    register(moduleName, module) {
        _.extend(this.modules, { [moduleName]: module });

        if (typeof this.modules[moduleName].init === 'function') {
            this.modules[moduleName].init();
        }
    },
};

/**
 * Modules
 */

// import cookieConsent from './modules/cookie-consent'
import core from './modules/core';
import form from './modules/form';
import googleMaps from './modules/google-maps';
import lab from './modules/lab';
import map from './modules/map';
import mapStyles from './modules/map-styles';
import nav from './modules/nav';
import report from './modules/report';
import reportForm from './modules/report-form';
import reportAdminForm from './modules/report-admin-form';
import reportFormLocation from './modules/report-form-location';
import reportFormSketch from './modules/report-form-sketch';
import reportFormPhotos from './modules/report-form-photos';
import reportIdentifier from './modules/report-identifier';
import share from './modules/share';
import sidebar from './modules/sidebar';
import lazyLoad from './modules/lazy-load';
import ufoAlert from './modules/ufo-alert';

// These first!
app.register('core', core);
app.register('mapStyles', mapStyles);

// app.register('cookieConsent', cookieConsent)
app.register('form', form);
app.register('googleMaps', googleMaps);
app.register('nav', nav);
app.register('share', share);

if (app.isRequired('lab')) {
    app.register('lab', lab);
}

if (app.isRequired('lazyLoad')) {
    app.register('lazyLoad', lazyLoad);
}

if (app.isRequired('map')) {
    app.register('map', map);
}

if (app.isRequired('report')) {
    app.register('report', report);
}

if (app.isRequired('reportAdminForm')) {
    app.register('reportAdminForm', reportAdminForm);
}

if (app.isRequired('reportForm')) {
    app.register('reportForm', reportForm);
}

if (app.isRequired('reportFormLocation')) {
    app.register('reportFormLocation', reportFormLocation);
}

if (app.isRequired('reportFormPhotos')) {
    app.register('reportFormPhotos', reportFormPhotos);
}

if (app.isRequired('reportFormSketch')) {
    app.register('reportFormSketch', reportFormSketch);
}

if (app.isRequired('reportIdentifier')) {
    app.register('reportIdentifier', reportIdentifier);
}

if (app.isRequired('sidebar')) {
    app.register('sidebar', sidebar);
    app.register('ufoAlert', ufoAlert);
}
